import React from 'react';
import {
  getCustomerType,
  getGender,
  getHighRiskPartyInfo,
  getRiskRatingColor
} from '../../../../components/TableHeader/tableRowUtils';
import { find, startCase } from 'lodash';
import {
  HighRiskPartyLabel,
  RiskRatingComponent,
  HighRiskPartyInformation
} from '../../../../components/CustomerProfileViewComponent';
import { segmentMapping } from '../ClusterInformation';

export const IndividualConf = [
  [
    {
      label: 'Customer ID',
      attribute: 'customer_id',
      priority: 0
    },
    {
      label: 'Customer Name',
      attribute: 'partyName',
      priority: 1
    },
    {
      label: 'Customer Type',
      attribute: 'customerType',
      isFormattedFunc: true,
      formatterFunc: getCustomerType,
      priority: 2
    },
    {
      label: 'Segment',
      attribute: 'segmentCode',
      priority: 3,
      isCustomFunc: true,
      customFunction: (segmentCode) => {
        const { segmentName = 'NA' } = find(segmentMapping, {
          segmentCode: segmentCode
        });
        return segmentName;
      }
    },
    {
      label: 'Division',
      attribute: 'division',
      priority: 4
    },
    {
      label: 'Type of Business',
      attribute: 'typeOfBusiness',
      priority: 5
    }
  ],
  [
    {
      label: 'Age',
      attribute: 'age',
      priority: 0
    },
    {
      label: 'Date of Birth',
      attribute: 'dobOrIncorporationDate',
      priority: 1
    },
    {
      label: 'Registered Address',
      attribute: 'residentialAddress',
      priority: 2
    },
    {
      label: 'Postal Code',
      attribute: 'postalCode',
      priority: 3
    },
    {
      label: 'Contact Number',
      attribute: 'contactNumber',
      priority: 4
    },
    {
      label: 'Designation',
      attribute: 'designation',
      priority: 5
    }
  ],
  [
    {
      label: 'Gender',
      attribute: 'gender',
      isFormattedFunc: true,
      formatterFunc: getGender,
      priority: 0
    },
    {
      label: 'Nationality',
      attribute: 'nationality',
      priority: 1
    },
    {
      label: 'ID Number',
      attribute: 'documentId',
      priority: 2
    },
    {
      label: 'ID Type',
      attribute: 'documentType',
      priority: 3
    },
    {
      label: 'ID Country',
      attribute: 'documentIssueCountry',
      priority: 4
    },
    {
      label: 'Employer Name',
      attribute: 'employerName',
      priority: 5
    }
  ],
  [
    {
      label: 'PEP/PEC',
      attribute: 'pepInd',
      isCustomFunc: true,
      customFunction: (pepInd) => {
        return startCase(pepInd ? 'yes' : 'no');
      },
      priority: 0
    },
    {
      label: 'High Risk Party Information',
      attribute: 'highRiskPartyInfo',
      isCustomRenderer: true,
      customRenderer: (highRiskPartyInfo) => {
        return (
          <HighRiskPartyInformation highRiskPartyInfo={highRiskPartyInfo} />
        );
      },
      priority: 2
    },
    {
      label: 'KYC Risk Rating',
      attribute: 'riskRating',
      priority: 1,
      isCustomRenderer: true,
      customRenderer: (riskRating, label) => {
        const riskRatingObject = getRiskRatingColor(riskRating);
        return (
          <RiskRatingComponent
            label={label}
            crsVersion={true}
            riskRatingObject={riskRatingObject}
          />
        );
      }
    },
    // {
    //   label: '- Expiration Date',
    //   attribute: 'highRiskPartyInfo',
    //   isCustomFunc: true,
    //   customFunction: (highRiskPartyInfo) => {
    //     return getHighRiskPartyInfo(highRiskPartyInfo).expirationDate;
    //   },
    //   priority: 3
    // },
    // {
    //   label: '- Predefined Comments',
    //   attribute: 'highRiskPartyInfo',
    //   isCustomFunc: true,
    //   customFunction: (highRiskPartyInfo) => {
    //     return getHighRiskPartyInfo(highRiskPartyInfo).predefinedComments;
    //   },
    //   priority: 4
    // },
    {
      label: 'Staff Indicator',
      attribute: 'isStaff',
      isCustomFunc: true,
      customFunction: (isStaff) => {
        return startCase(Boolean(isStaff).toString());
      },
      priority: 5
    }
  ]
];
export const CorporateConf = [
  [
    {
      label: 'Customer ID',
      attribute: 'customer_id',
      priority: 0
    },
    {
      label: 'Customer Name',
      attribute: 'partyName',
      priority: 1
    },
    {
      label: 'Customer Type',
      attribute: 'customerType',
      isFormattedFunc: true,
      formatterFunc: getCustomerType,
      priority: 2
    },
    {
      label: 'Segment',
      attribute: 'segmentCode',
      priority: 3,
      isCustomFunc: true,
      customFunction: (segmentCode) => {
        const { segmentName = 'NA' } = find(segmentMapping, {
          segmentCode: segmentCode
        });
        return segmentName;
      }
    },
    {
      label: 'Division',
      attribute: 'division',
      priority: 4
    },
    {
      label: 'Nature of Business',
      attribute: 'typeOfBusiness',
      priority: 5
    }
  ],
  [
    {
      label: 'Place of Incorporation',
      attribute: 'birthIncorporationCountry',
      priority: 0
    },
    {
      label: 'Date of Incorporation',
      attribute: 'dobOrIncorporationDate',
      priority: 1
    },
    {
      label: 'Country of Operation',
      attribute: 'residenceOperationCountry',
      priority: 2
    },
    {
      label: 'Postal Code',
      attribute: 'postalCode',
      priority: 3
    },
    {
      label: 'Contact Number',
      attribute: 'contactNumber',
      priority: 4
    }
  ],
  [
    {
      label: 'ID Number',
      attribute: 'documentId',
      priority: 0
    },
    {
      label: 'ID Type',
      attribute: 'documentType',
      priority: 1
    },
    {
      label: 'ID Country',
      attribute: 'documentIssueCountry',
      priority: 3
    },
    {
      label: 'Registered Address',
      attribute: 'residentialAddress',
      priority: 4
    }
  ],
  [
    {
      label: 'Annual Turnover',
      attribute: 'annualTurnover',
      priority: 0
    },
    {
      label: 'PEP/PEC',
      attribute: 'pepInd',
      isCustomFunc: true,
      customFunction: (pepInd) => {
        return startCase(pepInd ? 'yes' : 'no');
      },
      priority: 1
    },
    {
      label: 'High Risk Party Information',
      attribute: 'highRiskPartyInfo',
      isCustomRenderer: true,
      customRenderer: (highRiskPartyInfo) => {
        return (
          <HighRiskPartyInformation highRiskPartyInfo={highRiskPartyInfo} />
        );
      },
      priority: 2
    },
    {
      label: 'KYC Risk Rating',
      attribute: 'riskRating',
      priority: 3,
      isCustomRenderer: true,
      customRenderer: (riskRating, label) => {
        const riskRatingObject = getRiskRatingColor(riskRating);
        return (
          <RiskRatingComponent
            label={label}
            crsVersion={true}
            riskRatingObject={riskRatingObject}
          />
        );
      }
    },
    {
      label: 'Staff Indicator',
      attribute: 'isStaff',
      isCustomFunc: true,
      customFunction: (isStaff) => {
        return startCase(Boolean(isStaff).toString());
      },
      priority: 5
    }
    // {
    //   label: '- Expiration Date',
    //   attribute: 'highRiskPartyInfo',
    //   isCustomFunc: true,
    //   customFunction: (highRiskPartyInfo) => {
    //     return getHighRiskPartyInfo(highRiskPartyInfo).expirationDate;
    //   },
    //   priority: 4
    // },
    // {
    //   label: '- Predefined Comments',
    //   attribute: 'highRiskPartyInfo',
    //   isCustomFunc: true,
    //   customFunction: (highRiskPartyInfo) => {
    //     return getHighRiskPartyInfo(highRiskPartyInfo).predefinedComments;
    //   },
    //   priority: 5
    // }
  ]
];

export const IndividualAttributeConf = IndividualConf.flat().reduce(
  (og, ob) => {
    og[ob.attribute] = ob;
    return og;
  },
  {}
);
export const CorporateAttributeConf = CorporateConf.flat().reduce((og, ob) => {
  og[ob.attribute] = ob;
  return og;
}, {});
